import React from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { togglePanel } from '../../store/slices/notificationSlice';

const NotificationBell: React.FC = () => {
  const dispatch = useDispatch();
  const { unreadCount } = useSelector((state: RootState) => state.notifications);

  const handleClick = () => {
    dispatch(togglePanel());
  };

  return (
    <Tooltip title="Notifications">
      <IconButton color="inherit" onClick={handleClick}>
        <Badge badgeContent={unreadCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default NotificationBell;
